import {SozUndArbeitsAnamneseLeer} from '../SozUndArbeitsAnamneseLeer';

const validateInteger = (e, min, max, hasError) => {
    const key = e.currentTarget.name;
    const neu = { ...hasError };
    try {
        neu[key] = false;
        // setHasError(neu);
        const val = e.currentTarget.value;
        if (val !== '') {
            const ival = parseInt(val);
            if (isNaN(ival) || (ival < min) || (ival > max) || !/^\d+$/.test(val)) {
                // console.log('MinMaxViolation or NaN detected', val)
                throw new Error('MinMax Violation');
            }
        }

        // console.log('validation OK', val, /^\d+$/.test(val))
        // handleChange(e);
    } catch (error) {
        // console.log('error caught', error)
        neu[key] = true
        // setHasError(neu);
        return { e: null, neu }
    }
    return { e, neu }
};

const validateSimpleDate = (e, hasError, setHasError, enhanceMax=0) => {
    const key = e.currentTarget.name;
    const neu = { ...hasError };
    try {
        neu[key] = false;
        // setHasError(neu);
        const val = e.currentTarget.value;
        if (val !== '') {
            const today = new Date();
            const thisYear = today.getFullYear();
            const ival = parseInt(val);
            // console.log(ival)
            if (isNaN(ival) || (ival < (thisYear - 100)) || (ival > (thisYear + enhanceMax))) {
                //console.log('MinMaxViolation or NaN detected', val)
                throw new Error('MinMax Violation');
            }
        }
    } catch (error) {
        // console.log('error caught', error)
        neu[key] = true
        // setHasError(neu);
        return { e: null, neu }
    }
    return { e, neu }
};

const typedReturnValue = (key, value) => {
    const defaultValues = SozUndArbeitsAnamneseLeer.SozUBeruf;
    return Number.isInteger(defaultValues[key]) ? (value !== '' ? parseInt(value) : 0) :value;
}

const handleIntegerBlur = (e, min, max, hasError, setHasError) => {
    // console.log('blur occurred', e.target)
    e.preventDefault();
    const name = e.currentTarget.name;
    const retVal = validateInteger(e, min, max, hasError);
    setHasError(retVal.neu);
    if (retVal.neu[name]) {
        // console.log('handleBlur::value has error', retVal.neu);
        e.currentTarget.focus();
    }
}

const handleInteger = (e, handleChange, min, max, hasError, setHasError) => {
    e.preventDefault();
    const first = e.currentTarget.value.slice(0, -1), lastChar = e.currentTarget.value.slice(-1);
    const retVal = validateInteger(e, min, max, hasError);

    // console.log('handleInteger:', first, lastChar);
    if (((lastChar >= '0') && (lastChar <= '9')) || lastChar === '') {
        if (retVal.e) { // no error thrown, so reset error
            setHasError(retVal.neu);
        }
        handleChange(e);
    } else {
        e.currentTarget.value = first;
    }
}

const handleSimpleDateBlur = (e, hasError, setHasError, enhanceMax=0) => {
    const name = e.currentTarget.name;
    const retVal = validateSimpleDate(e, hasError, setHasError, enhanceMax);
    setHasError(retVal.neu);
    if (retVal.neu[name]) {
        // console.log('handleBlur::value has error', retVal.neu);
        e.currentTarget.focus();
    }
}

const handleSimpleDate = (e, handleChange, hasError, setHasError, enhanceMax=0) => {
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;
    const first = e.currentTarget.value.slice(0, -1), lastChar = e.currentTarget.value.slice(-1);
    const retVal = validateSimpleDate(e, hasError, setHasError, enhanceMax);
    if (((lastChar >= '0') && (lastChar <= '9')) || lastChar === '') {
        if (retVal.e) { // no error thrown, so reset error
            setHasError(retVal.neu);
        }
        handleChange({ target: { name, value } });
    } else {
        e.currentTarget.value = first;
    }
}


export { validateInteger, typedReturnValue, handleSimpleDate, handleSimpleDateBlur, handleInteger, handleIntegerBlur };